import CallwithUs from './CallwithUs/CallwithUs';
import DownloadApp from './DownloadApp/DownloadApp';
import IntroductionBoostan from './IntroductionBoostan';
import LinkToMessenger from './LinkToMessenger';
import SliderImage from './Slider/SliderImage';

function MainScreen() {
    return (
        <div className='bg-purpleLight pb-10'>
            <IntroductionBoostan />
            <SliderImage />
            <DownloadApp />
            <LinkToMessenger />
            <CallwithUs />
        </div>
    );
}
export default MainScreen;